import varint from '../vendor/varint.js';
export const decode = function (data) {
  let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const code = varint.decode(data, offset);
  return [code, varint.decode.bytes];
};
export const encodeTo = function (int, target) {
  let offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  varint.encode(int, target, offset);
  return target;
};
export const encodingLength = int => {
  return varint.encodingLength(int);
};